module.exports = __webpack_public_path__ + "static/media/feature-coffee-2.e2b68635.jpg";